export const SUB_ROUTE_SPORT = 'sport' as const;
export const SUB_ROUTE_SPORT_ID = `${SUB_ROUTE_SPORT}/:sportIdWithSlug` as const;

const LivePageSubRoutes = {
	SPORT: [SUB_ROUTE_SPORT, SUB_ROUTE_SPORT_ID]
} as const;

export default LivePageSubRoutes;
